import React from 'react';

function MobileDoctorLogout({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-[300] flex items-end" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="w-full bg-white rounded-t-3xl p-6 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
            <span className="material-symbols-outlined text-red-500" style={{ fontSize: '36px', fontVariationSettings: '"FILL" 1' }}>logout</span>
          </div>
          <h2 className="text-xl font-black text-[#0d1b2a] mb-1">Logout?</h2>
          <p className="text-gray-400 text-sm">Are you sure you want to logout from MyHealth Journal?</p>
        </div>
        <div className="flex gap-3">
          <button onClick={onCancel}
            className="flex-1 py-4 border-2 border-gray-200 text-gray-600 font-bold rounded-2xl text-sm active:scale-95">
            Cancel
          </button>
          <button onClick={onConfirm}
            className="flex-1 py-4 bg-red-500 text-white font-bold rounded-2xl text-sm active:scale-95"
            style={{ boxShadow: '0 8px 20px rgba(239,68,68,0.3)' }}>
            Yes, Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileDoctorLogout;